import { render, staticRenderFns } from "./NewChatAudioPlayer.vue?vue&type=template&id=23bfe95b"
import script from "./NewChatAudioPlayer.vue?vue&type=script&lang=js"
export * from "./NewChatAudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./NewChatAudioPlayer.vue?vue&type=style&index=0&id=23bfe95b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports